const APPLE_CATEGORIES = [
  'Books',
  'Business',
  'Developer Tools',
  'Education',
  'Entertainment',
  'Finance',
  'Food & Drink',
  'Games',
  'Graphics & Design',
  'Health & Fitness',
  'Lifestyle',
  'Magazines & Newspapers',
  'Medical',
  'Music',
  'Navigation',
  'News',
  'Photo & Video',
  'Productivity',
  'Reference',
  'Shopping',
  'Social Networking',
  'Sports',
  'Stickers',
  'Travel',
  'Utilities',
  'Weather',
];

const ROKU_CATEGORIES = [
  'Animals & Pets',
  'Apps',
  'Cars & Motorcycles',
  'Classic TV',
  'Comedy',
  'Crime & Mystery',
  'Drama',
  'Educational',
  'eSports & Gaming',
  'Faith-Based',
  'Food & Home',
  'Games',
  'Health & Wellness',
  'How To',
  'International',
  'Kids & Family',
  'Lifestyle',
  'Local News',
  'Movies & TV',
  'Music',
  'News',
  'Personal Media',
  'Photo Apps',
  'Premium Services',
  'Reality & Pop Culture',
  'Relaxation & Meditation',
  'Rent/Buy Movies',
  'Sci & Tech',
  'Screensavers',
  'Shopping',
  'Special Interest',
  'Sports',
  'Subscription Channels',
  'TV en Español',
  'Travel',
  'Watch With Cable',
  'Weather',
  'Web Video',
];

export default class SettingsAppearanceController {
  constructor(Account, Broadcast, $rootScope, $uibModal, $q, toaster, AppleTvApp, RokuApp) {
    'ngInject';

    this.Account = Account;
    this.Broadcast = Broadcast;
    this.$uibModal = $uibModal;
    this.$q = $q;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.canEditAccountSettings = $rootScope.user.can('update', 'account');
    this.toaster = toaster;
    this.AppleTvApp = AppleTvApp;
    this.RokuApp = RokuApp;

    this.refresh();
  }

  rokuImageList() {
    if (!this.rokuApp) {
      return null;
    }
    if (this._rokuImageList) {
      return this._rokuImageList;
    }
    let r = this.rokuApp;
    this._rokuImageList = [
      { id: 'logo', name: 'Logo', src: r.logo, noValidate: true, preview_w: 300, preview_h: 100 },
      { id: 'icon', name: 'App Icon', src: r.icon, w: 540, h: 405, preview_w: 180, preview_h: 135 },
      {
        id: 'channel_store_icon_fhd',
        name: 'Store Icon Full HD',
        src: r.channel_store_icon_fhd,
        w: 540,
        h: 405,
        preview_w: 180,
        preview_h: 135,
      },
      {
        id: 'channel_store_icon_large',
        name: 'Store Icon Large',
        src: r.channel_store_icon_large,
        w: 336,
        h: 210,
        preview_w: 168,
        preview_h: 105,
      },
      {
        id: 'channel_store_icon_small',
        name: 'Store Icon Small',
        src: r.channel_store_icon_small,
        w: 246,
        h: 140,
        preview_w: 123,
        preview_h: 70,
      },
      {
        id: 'splash_screen_fhd',
        name: 'Splash Full HD',
        src: r.splash_screen_fhd,
        w: 1920,
        h: 1080,
        preview_w: 384,
        preview_h: 216,
      },
      {
        id: 'splash_screen_hd',
        name: 'Splash Large',
        src: r.splash_screen_hd,
        w: 1280,
        h: 720,
        preview_w: 240,
        preview_h: 135,
      },
      {
        id: 'splash_screen_sd',
        name: 'Splash Small',
        src: r.splash_screen_sd,
        w: 720,
        h: 480,
        preview_w: 162,
        preview_h: 108,
      },
    ];
    return this._rokuImageList;
  }

  appleTVImageList() {
    if (!this.appleTVApp) {
      return null;
    }
    if (this._appleTVImageList) {
      return this._appleTVImageList;
    }
    let a = this.appleTVApp;
    this._appleTVImageList = [
      {
        id: 'app_icon_background_layer',
        name: 'App Icon Background',
        src: a.app_icon_background_layer,
        w: 1280,
        h: 768,
        preview_w: 360,
        preview_h: 216,
      },
      {
        id: 'app_icon_foreground_layer',
        name: 'App Icon Foreground',
        src: a.app_icon_foreground_layer,
        w: 1280,
        h: 768,
        preview_w: 360,
        preview_h: 216,
      },
      {
        id: 'app_icon_small_background_layer_2x',
        name: 'App Icon Small Background',
        src: a.app_icon_small_background_layer_2x,
        w: 800,
        h: 480,
        preview_w: 180,
        preview_h: 108,
      },
      {
        id: 'app_icon_small_foreground_layer_2x',
        name: 'App Icon Small Foreground',
        src: a.app_icon_small_foreground_layer_2x,
        w: 800,
        h: 480,
        preview_w: 180,
        preview_h: 108,
      },
      {
        id: 'launch_image',
        name: 'Launch Image',
        src: a.launch_image,
        w: 1920,
        h: 1080,
        preview_w: 384,
        preview_h: 216,
      },
      {
        id: 'top_shelf_image_2x',
        name: 'Top Shelf Image',
        src: a.top_shelf_image_2x,
        w: 3840,
        h: 1440,
        preview_w: 317,
        preview_h: 119,
      },
      {
        id: 'top_shelf_wide_image_2x',
        name: 'Top Shelf Wide Image',
        src: a.top_shelf_wide_image_2x,
        w: 4640,
        h: 1440,
        preview_w: 384,
        preview_h: 119,
      },
    ];
    return this._appleTVImageList;
  }

  statusText(app) {
    if (app && app.status) {
      return (
        {
          waiting_on_customer: 'Waiting for Your Submission',
          submitted_to_boxcast: 'In Development',
          submitted_for_review: 'In Review',
          released: 'Released',
          removed: 'Removed',
        }[app.status] || 'Unknown'
      );
    }
    return 'Unknown';
  }

  statusLabelLevel(app) {
    if (app && app.status) {
      return (
        {
          waiting_on_customer: 'warning',
          submitted_to_boxcast: 'info',
          submitted_for_review: 'info',
          released: 'success',
          removed: 'danger',
        }[app.status] || 'default'
      );
    }
    return 'default';
  }

  statusLabelTooltip(app) {
    if (app && app.status) {
      return (
        {
          waiting_on_customer:
            'Configure your organization\'s app information and images by selecting "Edit Information". When complete, click "Submit to BoxCast".',
          submitted_to_boxcast:
            "Your organization's information has been sent, and your app is being built by BoxCast.",
          submitted_for_review: "Your organization's app has been submitted for review.",
          released: "Your organization's app is live.",
          removed: "Your organization's app has been removed.",
        }[app.status] || ''
      );
    }
    return '';
  }

  allAppleTVFieldsSet() {
    return hasAllFieldsSet(this.appleTVApp, [
      'apple_developer_account_name',
      'name',
      'subtitle',
      'category',
      'promotional_text',
      'keywords',
      'description',
      'app_icon_background_layer',
      'app_icon_foreground_layer',
      'app_icon_small_background_layer_2x',
      'app_icon_small_foreground_layer_2x',
      'launch_image',
      'top_shelf_image_2x',
      'top_shelf_wide_image_2x',
    ]);
  }

  updateAppleTVAppReadyToSubmit() {
    if (this.appleTVApp) {
      this.appleTVApp._ready_to_submit =
        this.allAppleTVFieldsSet() && !this.needPublicRecordedBroadcasts;
    }
  }

  allRokuFieldsSet() {
    return hasAllFieldsSet(this.rokuApp, [
      'roku_developer_account_name',
      'channel_name',
      'channel_description',
      'web_description',
      'category',
      'more_information_url',
      'splash_screen_fhd',
      'splash_screen_hd',
      'splash_screen_sd',
      'channel_store_icon_fhd',
      'channel_store_icon_large',
      'channel_store_icon_small',
      'logo',
      'icon',
    ]);
  }

  updateRokuAppReadyToSubmit() {
    if (this.rokuApp) {
      this.rokuApp._ready_to_submit = this.allRokuFieldsSet() && !this.needPublicRecordedBroadcasts;
    }
  }

  refresh() {
    this.account = this.Account.get();

    let appleTVPromise = this.AppleTvApp.query({ s: '-created_at', l: 1 })
      .$promise.then((result) => {
        if (result && result.length) {
          this.appleTVApp = this.AppleTvApp.get({ id: result[0].id });
          return this.appleTVApp.$promise;
        }
      })
      .then(() => {
        this.updateAppleTVAppReadyToSubmit();
        delete this._appleTVImageList;
      });
    let rokuPromise = this.RokuApp.query({ s: '-created_at', l: 1 })
      .$promise.then((result) => {
        if (result && result.length) {
          this.rokuApp = this.RokuApp.get({ id: result[0].id });
          return this.rokuApp.$promise;
        }
      })
      .then(() => {
        this.updateRokuAppReadyToSubmit();
        delete this._rokuImageList;
      });

    // Keep track of loading state of AJAX requests
    this.loadingPromises = [this.account.$promise, appleTVPromise, rokuPromise];

    // After we get the apple tv and roku apps, check to see if we need to look for public, recorded broadcasts
    this.needPublicRecordedBroadcasts = false;
    this.$q.all([appleTVPromise, rokuPromise]).then(() => {
      // We only need to check for public, recorded broadcasts if at least one app exists and is waiting_on_customer.
      let needsBroadcastQuery = false;
      if (
        (this.rokuApp && this.rokuApp.status == 'waiting_on_customer') ||
        (this.appleTVApp && this.appleTVApp.status == 'waiting_on_customer')
      ) {
        needsBroadcastQuery = true;
      }
      if (!needsBroadcastQuery) {
        return;
      }

      // If we get here, we need to go check for public, recorded broadcasts
      this.needPublicRecordedBroadcasts = true;
      this.updateAppleTVAppReadyToSubmit();
      this.updateRokuAppReadyToSubmit();
      this.loadingPromises.push(
        this.Broadcast.query(
          {
            'filter.exclude_past_live_only': true,
            q: `timeframe:past`,
            l: 1000,
            s: `-starts_at`,
          },
          (broadcasts) =>
            _.find(broadcasts, (b) => {
              if (!b.is_private && !b.is_ticketed && b.recording_duration_seconds > 0) {
                this.needPublicRecordedBroadcasts = false;
                this.updateAppleTVAppReadyToSubmit();
                this.updateRokuAppReadyToSubmit();
                return true;
              }
              return false;
            }),
          (err) => {
            console.error(err);
            toaster.pop('warning', 'Unable to find recorded broadcasts.');
          }
        ).$promise
      );
    });
  }

  submitToBoxCast(type, app) {
    const { RokuApp, AppleTvApp, toaster } = this;

    if (type == 'roku') {
      this.rokuApp._submitting = true;
      RokuApp.update(
        { id: app.id, status: 'submitted_to_boxcast' },
        (app) => {
          this.rokuApp = app;
        },
        (err) => {
          console.error(err);
          this.rokuApp._submitting = false;
          toaster.pop(
            'warning',
            'Unable to submit app. Please confirm all fields have been filed out and try again.'
          );
        }
      );
    } else if (type == 'appletv') {
      this.appleTVApp._submitting = true;
      AppleTvApp.update(
        { id: app.id, status: 'submitted_to_boxcast' },
        (app) => {
          this.appleTVApp = app;
        },
        (err) => {
          console.error(err);
          this.appleTVApp._submitting = false;
          toaster.pop(
            'warning',
            'Unable to submit app. Please confirm all fields have been filed out and try again.'
          );
        }
      );
    } else {
      console.error('Unknown submission type: ', type, app);
    }
  }

  showEditAppearanceModal() {
    const { $uibModal } = this;
    const parentVM = this;

    $uibModal.open({
      template: require('./modal-edit-appearance.html'),
      controller: require('./modal-edit-content-settings.js').default,
      controllerAs: 'vm',
      resolve: {
        parentVM: () => parentVM,
      },
      //  Prevent accidental close...
      keyboard: false,
      backdrop: 'static',
    });
  }

  showEditRokuModal() {
    const { $uibModal } = this;
    const parentVM = this;

    $uibModal.open({
      template: require('./modal-edit-roku.html'),
      controller: ModalEditRokuController,
      controllerAs: 'vm',
      resolve: {
        parentVM: () => parentVM,
      },
      size: 'lg',
      //  Prevent accidental close...
      keyboard: false,
      backdrop: 'static',
    });
  }

  showEditAppleTVModal() {
    const { $uibModal } = this;
    const parentVM = this;

    $uibModal.open({
      template: require('./modal-edit-appletv.html'),
      controller: ModalEditAppleTVController,
      controllerAs: 'vm',
      resolve: {
        parentVM: () => parentVM,
      },
      size: 'lg',
      //  Prevent accidental close...
      keyboard: false,
      backdrop: 'static',
    });
  }
}

function ModalEditRokuController(parentVM, $uibModalInstance, $rootScope, RokuApp, toaster) {
  'ngInject';

  this.app = angular.copy(parentVM.rokuApp);
  this.images = angular.copy(parentVM.rokuImageList());
  this.categories = ROKU_CATEGORIES;

  const account = parentVM.account;
  this.app.channel_name =
    this.app.channel_name || account.content_settings.display_name || account.name;
  this.app.channel_description =
    this.app.channel_description || account.content_settings.description;
  this.app.web_description = this.app.web_description || account.content_settings.description;
  this.app.more_information_url = this.app.more_information_url || account.content_settings.website;
  this.app.end_user_support_contact = this.app.end_user_support_contact || 'questions@boxcast.com';
  const defaultCategory =
    account.market === 'house-of-worship' ? 'Faith-Based' : 'Special Interest';
  this.app.category = this.app.category || defaultCategory;

  this.uploads = {};
  this.files = {};
  this.images.forEach((img) => {
    this.uploads[img.id] = null;
    this.files[img.id] = null;
  });

  this.limits = $rootScope.ApiConfig.modelFieldLimits('roku_app', 'maximum');

  this.cancel = () => $uibModalInstance.dismiss();

  this.onChangeImage = (img) => {
    img.src = '';
    this.app[img.id] = '';
    this.uploads[img.id] = null;
    this.files[img.id] = null;
  };

  this.onLoadImage = (img, $event) => {
    this.uploads[img.id] = {
      naturalWidth: $event.target.naturalWidth,
      naturalHeight: $event.target.naturalHeight,
    };
  };

  this.uploadInto = (img, file) => {
    file.upload().then((response) => {
      img.src = response.view_url;
      this.app[img.id] = response.view_url;
    });
  };

  this.update = () => {
    this.showError = false;
    this.saving = true;
    const appUpdate = angular.copy(this.app);
    delete appUpdate.status;
    RokuApp.update(
      appUpdate,
      (app) => {
        parentVM.refresh();
        this.cancel();
      },
      (err) => {
        this.saving = false;
        console.error(err);
        toaster.pop('warning', 'There was an error saving your app submission. Please try again.');
      }
    );
  };
}

function ModalEditAppleTVController(parentVM, $uibModalInstance, $rootScope, AppleTvApp, toaster) {
  'ngInject';

  this.app = angular.copy(parentVM.appleTVApp);
  this.images = angular.copy(parentVM.appleTVImageList());
  this.categories = APPLE_CATEGORIES;

  const account = parentVM.account;
  this.app.name = this.app.name || account.content_settings.display_name || account.name;
  this.app.description = this.app.description || account.content_settings.description;
  this.app.marketing_url = this.app.marketing_url || account.content_settings.website;
  this.app.support_url = this.app.support_url || 'https://support.boxcast.com';
  this.app.category = this.app.category || 'Lifestyle';

  this.uploads = {};
  this.files = {};
  this.images.forEach((img) => {
    this.uploads[img.id] = null;
    this.files[img.id] = null;
  });

  this.limits = $rootScope.ApiConfig.modelFieldLimits('apple_tv_app', 'maximum');

  this.cancel = () => $uibModalInstance.dismiss();

  this.onChangeImage = (img) => {
    img.src = '';
    this.app[img.id] = '';
    this.uploads[img.id] = null;
    this.files[img.id] = null;
  };

  this.onLoadImage = (img, $event) => {
    this.uploads[img.id] = {
      naturalWidth: $event.target.naturalWidth,
      naturalHeight: $event.target.naturalHeight,
    };
  };

  this.uploadInto = (img, file) => {
    file.upload().then((response) => {
      img.src = response.view_url;
      this.app[img.id] = response.view_url;
    });
  };

  const resizeURL = (origURL, w, h) =>
    `https://images.weserv.nl/?url=${encodeURIComponent(origURL)}&w=${w}&h=${h}&fit=fill`;

  const shapeUpdateParams = (app) => {
    // Make a copy to not mutate the original object
    const ret = angular.copy(this.app);

    // Don't post the status, which isn't changing
    delete ret.status;

    // Fill in resize URLs for 1x versions of 2x images
    if (ret.top_shelf_image_2x) {
      ret.top_shelf_image = resizeURL(ret.top_shelf_image_2x, 1920, 720);
    }
    if (ret.top_shelf_wide_image_2x) {
      ret.top_shelf_wide_image = resizeURL(ret.top_shelf_wide_image_2x, 2320, 720);
    }
    if (ret.app_icon_small_background_layer_2x) {
      ret.app_icon_small_background_layer = resizeURL(
        ret.app_icon_small_background_layer_2x,
        400,
        240
      );
    }
    if (ret.app_icon_small_foreground_layer_2x) {
      ret.app_icon_small_foreground_layer = resizeURL(
        ret.app_icon_small_foreground_layer_2x,
        400,
        240
      );
    }

    return ret;
  };

  this.update = () => {
    this.showError = false;
    this.saving = true;
    AppleTvApp.update(
      shapeUpdateParams(this.app),
      (app) => {
        parentVM.refresh();
        this.cancel();
      },
      (err) => {
        this.saving = false;
        console.error(err);
        toaster.pop('warning', 'There was an error saving your app submission. Please try again.');
      }
    );
  };
}

function hasAllFieldsSet(app, fields) {
  let missingAny = false;
  fields.forEach((k) => (missingAny = missingAny || !app[k].trim()));
  return !missingAny;
}



// WEBPACK FOOTER //
// ./app/pages/settings/appearance.js